import React from 'react';
import { 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem, 
  CircularProgress,
  FormHelperText
} from '@mui/material';
import { useGetAllUsuariosQQuery } from '../../store/api/endpoints/usuariosApiSlice'; 

export const SelectVendedor = ({
  value,
  onChange,
  label = "Vendedor",
  name = "vendedorId",
  fullWidth = true,
  size = "medium",
  required = false,
}) => {
  // Consumo de RTK Query
  const { data: usuarios = [], isLoading, isError } = useGetAllUsuariosQQuery();

  const handleChange = (event) => {
    // Pasamos el valor seleccionado directamente al padre
    onChange(event.target.value);
  };

  return (
    <FormControl 
      fullWidth={fullWidth} 
      size={size} 
      error={isError} 
      required={required}
    >
      <InputLabel id="select-vendedor-label">{label}</InputLabel>
      <Select
        labelId="select-vendedor-label"
        id="select-vendedor"
        name={name}
        value={value}
        label={label}
        onChange={handleChange}
        disabled={isLoading}
        // Spinner integrado nativo de MUI v6 para la carga
        endAdornment={
          isLoading ? (
            <CircularProgress color="inherit" size={20} style={{ marginRight: 24 }} />
          ) : null
        }
      >

        {/* Renderizado de la lista que viene de la API */}
        {!isLoading && usuarios.map((usuario) => (
          <MenuItem key={usuario._id} value={usuario._id}>
            {usuario.nombre}
          </MenuItem>
        ))}
      </Select>
      
      {isError && (
        <FormHelperText>Error al cargar los vendedores</FormHelperText>
      )}
    </FormControl>
  );
};